// API configuration
// In production, use relative URLs (proxied through Vercel rewrites for same-origin)
// In development, use the full API URL
const isDevelopment = typeof window !== 'undefined' 
  ? window.location.hostname === 'localhost'
  : process.env.NODE_ENV === 'development';

const API_BASE_URL = isDevelopment 
  ? (process.env.GATSBY_API_URL || 'http://localhost:3003')
  : '';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  LOGOUT: `${API_BASE_URL}/api/auth/logout`,
  REGISTER: `${API_BASE_URL}/api/auth/register`,
  ME: `${API_BASE_URL}/api/auth/me`,

  // Students
  STUDENTS_CREATE: `${API_BASE_URL}/api/students/create`,
  STUDENTS_LIST: `${API_BASE_URL}/api/students/list`,
  STUDENTS_DELETE: `${API_BASE_URL}/api/students/delete`,

  // Responses
  RESPONSES_SAVE: `${API_BASE_URL}/api/responses/save`,
  RESPONSES_PAGE: `${API_BASE_URL}/api/responses/page`,
  RESPONSES_STUDENT: `${API_BASE_URL}/api/responses/student`,
};

export default API_BASE_URL;
